import { categoryFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';
import gql from 'graphql-tag';

export const addCategoryMutation = gql`
  mutation AddCategory($input: CreateCategoryInput!) {
    addCategory(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminCategoryFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${categoryFieldsFragment}
`;